import type { BaseTableParams } from "@dashboardApi/apis/types";
import type { TableResult } from "@tanstack/react-table";

import type sharedConstants from "@lib/shared_constants";
import type { ObjectStatus } from "@lib/status";

export type ToneType =
  (typeof sharedConstants.GENERATIVE_AI.TONES)[keyof typeof sharedConstants.GENERATIVE_AI.TONES];

export interface BrandGuidelinesDataParams extends BaseTableParams {
  groupby?: never;
  /** the query object containing all the filters */
  query?: Partial<Record<string, string | string[]>>;
}

export enum CopywriterSettingsType {
  MESSAGE_SET = "message_set",
  BRAND_GUIDELINE = "brand_guideline",
}

export interface BrandGuideline {
  /* The id is required here for use in the DataTable. */
  id: string;
  name?: string;
  description?: string;
  /* primary text field to be used to define brand style for the prompt */
  brand_personality?: string;
  /* optional field for exclusions that the end client can add */
  exclusions?: string;
  /* optional field that is used to describe the purpose and role, currently not used in the prompt */
  guideline_purpose?: string;
  app_group_id?: string;
  /* describes status of the brand guideline - active or archived */
  status?: ObjectStatus;
  /* field to mark the default brand guideline to use */
  is_default?: boolean;
  /* optional field to describe the tone to use */
  tone_type?: ToneType;
  /* optional field to enumerate various copywriter settings. Currently only brand guidelines is used. */
  type?: CopywriterSettingsType;
  last_edited_by?: string;
  updated_at?: string;
}

export type BrandGuidelinesResult = TableResult<BrandGuideline>;

export interface TemporaryBrandGuideline extends Omit<BrandGuideline, "id"> {
  /* The id is optional here for use in the edit / create flow. */
  id?: string;
}
